// src/context/subscriptionprovider.js
import React, { createContext, useState, useEffect, useContext } from 'react'
import { getusersubscription } from '../services/data'
import validateJSON from '../util/jsonvalidation'
import { useAuth } from './logincontext'
import { useLocation } from 'react-router-dom'
import { useStoreId } from '../hooks/geturlstoreid' // your custom hook

const SubscriptionContext = createContext()

export const SubscriptionProvider = ({ children }) => {
  const [isRestricted, setIsRestricted] = useState(false)
  const [isactive, Setisactive] = useState(false)
  const [subscriptionData, setSubscriptionData] = useState(null)
  const [activePlan, setActivePlan] = useState('')
  const [limitedPermission, setLimitedPermission] = useState(null)
  const [loading, setLoading] = useState(true)

  const { userdata } = useAuth() || {}
  const location = useLocation()
  const store_id = useStoreId()

  const GetUserSubscription = async () => {
    const user_id = userdata?.id ?? ''
    if (!user_id || !store_id) return

    setLoading(true)
    try {
      const res = await getusersubscription(
        '',
        '',
        '',
        store_id,
        'active',
        ''
      )
      const activeSub = Array.isArray(res?.data) ? res.data[0] : res.data

      if (res.success && activeSub) {
        setActivePlan(activeSub.subscriptionPlan?.name || 'Unknown')
        setSubscriptionData(activeSub)

        const permissions = validateJSON(
          activeSub.subscriptionPlan?.limited_permission
        )
        setLimitedPermission(permissions)

        setIsRestricted(activeSub.status !== 'active')
        Setisactive(activeSub.status === 'active')
      } else {
        setIsRestricted(true)
        Setisactive(activeSub?.status === 'active')
      }
    } catch (err) {
      console.error('Error fetching subscription:', err)
      setIsRestricted(true)
      Setisactive(false)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    // Public routes (always unrestricted)
    const publicRoutes = [
      '/',
      '/register',
      '/forgot-password',
      '/reset-password',
      '/home',
      '/shopify/callback',
      '/pages/privacy-policy',
      '/pages/terms-conditions'
    ]

    if (publicRoutes.includes(location.pathname)) {
      setIsRestricted(false)
      Setisactive(false)
      setLoading(false)
      return
    }

    console.log(userdata, store_id)
    // Restricted: store-specific routes
    if (userdata?.id && store_id) {
      GetUserSubscription()
    } else {
      // Fallback for unexpected routes
      setIsRestricted(false)
      Setisactive(false)
      setLoading(false)
    }
  }, [userdata, store_id])

  return (
    <SubscriptionContext.Provider
      value={{
        isRestricted,
        isactive,
        subscriptionData,
        activePlan,
        limitedPermission,
        setIsRestricted,
        refreshSubscription: GetUserSubscription,
        loading
      }}
    >
      {children}
    </SubscriptionContext.Provider>
  )
}

export const useSubscription = () => useContext(SubscriptionContext)
